import { Pipe, PipeTransform, inject } from '@angular/core'
import { MaintenanceStatus } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
    name: 'translateMaintenanceStatus',
    standalone: false
})
export class TranslateMaintenanceStatusPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(status: MaintenanceStatus): string {
    return this.translateService.instant(`TRANSLATE_MAINTENANCE_STATUS.${constantCase(status)}`)
  }
}
